import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'

export const SearchSchema = z.object({
  tab: z.union([z.literal('details'), z.literal('consumption')]).default('details'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/equipment/energy/$equipmentId/')({
  validateSearch: SearchSchema,
  pendingComponent: PendingComponent,
})
